import React from "react";
import "../ComponentsWrapper/ComponentsWrapper.css";
import { useLocation } from "react-router-dom";
const ComponentsWrapper = () => {
  const location = useLocation();

  // 👇 Skip rendering if on homepage (route "/")
  if (location.pathname === "/") {
    return null;
  }
  return (
    <>
    
      {location.pathname !== '/' && (
        <div className="contents-wrapper-div">
          {/* Your content here */}
        </div>
      )}

    </>

  );
};

export default ComponentsWrapper;
